import getGradYear from '../get-grad-year'
import GRADE_LEVELS from '../../constants/grade-levels'

const calculateStudentGradeLevel = (graduationYear) => {
    if (!graduationYear || isNaN(graduationYear)) {
        return undefined
    }

    //  Student graduation year
    const gradYear = parseInt(graduationYear)

    const yearsToGraduate = gradYear - getGradYear()
    if (yearsToGraduate < 0) {
        return 'post graduate'
    }
    if (yearsToGraduate > 3) {
        return 'pre freshman'
    }
    switch(yearsToGraduate){
    case GRADE_LEVELS.SENIOR: return 'senior'
    case GRADE_LEVELS.JUNIOR: return 'junior'
    case GRADE_LEVELS.SOPHOMORE: return 'sophomore'
    case GRADE_LEVELS.FRESHMAN: return 'freshman'
    default: return 'unknown'
    }
}

export default calculateStudentGradeLevel